import {Component, Input, Output, EventEmitter} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-timepicker',
    templateUrl: './timepicker.component.html',
    styleUrls: ['./timepicker.component.scss']
})
export class TimepickerComponent {
    @Input() control!: FormControl;
    @Input() id!: string;
    @Output() timeSet: EventEmitter<string> = new EventEmitter<string>();

    onTimeSet(value: string): void {
        this.control.setValue(value);
        this.timeSet.emit(value);
        this.control.markAsDirty();
        this.control.markAsTouched();
    }
}
